import React, {useState, useEffect} from "react";
import Box from "@mui/material/Box";
import {IconButton} from "@mui/material";
import {QuickFix} from "../../interfaces/quickFix";
import QuickFixAndDrills from "../cards/quickFixAndDrills/quickFixAndDrills";
import {ArrowBackIos, ArrowForwardIos} from "@mui/icons-material";

function Carousel({items}: { items: QuickFix[] }) {
    const [currentPage, setCurrentPage] = useState(0);
    const [visibleCards, setVisibleCards] = useState<QuickFix[]>([]);

    const cardsPerPage = 3;
    const handleNextPage = () => {
        setCurrentPage((prevPage) => prevPage + 1);
    };

    const handlePrevPage = () => {
        setCurrentPage((prevPage) => prevPage - 1);
    };

    useEffect(() => {
        setVisibleCards(items.slice(currentPage, currentPage + cardsPerPage))
    }, [items, currentPage]);


    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                alignContent: "center",
                justifyContent: "center",
            }}
        >
            {items.length > 3 && 
            <IconButton
                disableRipple={true}
                onClick={handlePrevPage}
                sx={{
                    position: "absolute",
                    left: -30,
                    top: "38%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    zIndex: 1,
                    "&:hover": {backgroundColor: "unset"}
                }}
                // hidden={currentPage === 0}
                disabled={currentPage === 0}
            >
                <ArrowBackIos/>
            </IconButton>
            }


            <Box sx={{display: "flex"}}>
                {visibleCards.map((drill, index) => (
                    <QuickFixAndDrills key={index} drill={drill}
                                       last={index + 1 === items.length}></QuickFixAndDrills>
                ))}

                {items.length > 3 &&
                    <IconButton
                        disableRipple={true}
                        onClick={handleNextPage}
                        sx={{
                            position: "absolute",
                            right: -15,
                            top: "38%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            zIndex: 1,
                            "&:hover": {backgroundColor: "unset"}
                        }}
                        disabled={currentPage + cardsPerPage >= items.length}
                        // hidden={
                        //     currentPage + cardsPerPage === items.length
                        // }
                    >
                        <ArrowForwardIos/>
                    </IconButton>
                }
            </Box>




        </Box>
    );
}

export default Carousel;